import { render, staticRenderFns } from "./GenderConfig.vue?vue&type=template&id=5348f00c"
import script from "./GenderConfig.vue?vue&type=script&lang=js"
export * from "./GenderConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5348f00c')) {
      api.createRecord('5348f00c', component.options)
    } else {
      api.reload('5348f00c', component.options)
    }
    module.hot.accept("./GenderConfig.vue?vue&type=template&id=5348f00c", function () {
      api.rerender('5348f00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/GenderConfig.vue"
export default component.exports